import { levels } from '../scripts/systems/changeLevelSystem'

const spriteResources: Record<string, string> = {
	walrusHead1: 'sprites/walrus/head-1.png',
	walrusHead2: 'sprites/walrus/head-2.png',
	walrusHead3: 'sprites/walrus/head-3.png',
	walrusHead4: 'sprites/walrus/head-4.png',
	walrusHead5: 'sprites/walrus/head-5.png',
	walrusHead6: 'sprites/walrus/head-6.png',
	walrusHead7: 'sprites/walrus/head-7.png',
	walrusHead8: 'sprites/walrus/head-8.png',
	walrusHead9: 'sprites/walrus/head-9.png',
	walrusHeadCharge1: 'sprites/walrus/charged/head-charged-1.png',
	walrusHeadCharge2: 'sprites/walrus/charged/head-charged-2.png',
	walrusHeadCharge3: 'sprites/walrus/charged/head-charged-3.png',
	walrusHeadCharge4: 'sprites/walrus/charged/head-charged-4.png',
	walrusBody1: 'sprites/walrus/body-1.png',
	walrusBody2: 'sprites/walrus/body-2.png',
	walrusBody3: 'sprites/walrus/body-3.png',
	bench: 'sprites/platforms/bench.png',
	benchAngled: 'sprites/platforms/benchAngled.png',
	binoculars: 'sprites/platforms/binoculars.png',
	binocularsSilhouet: 'sprites/platforms/binocularsSilhouet.png',
	boat: 'sprites/platforms/boat.png',
	bunker: 'sprites/platforms/bunker.png',
	dogSign: 'sprites/platforms/dogSign.png',
	fenceWide: 'sprites/platforms/fenceWide.png',
	house: 'sprites/platforms/house.png',
	kaapsduinSign: 'sprites/platforms/kaapsduinSign.png',
	natureSignPost: 'sprites/platforms/natureSignPost.png',
	oar: 'sprites/platforms/oar.png',
	paaltje: 'sprites/platforms/paaltje.png',
	trunkHorizontal: 'sprites/platforms/trunkHorizontal.png',
	particle: 'sprites/particles/particle.png',
	dustParticle: 'sprites/particles/dust.png',
}
levels.forEach(level => (spriteResources[`world${level}`] = `sprites/levels/Warlus-${level}.png`))

export default spriteResources
